export class LoginModel {

    email = "";
    password = "";
    isEmailValid = true;
    errorMessage = null;
    isPasswordVisible = false;
}